import { FC } from "react";

import { MoreHoriz } from "@livechat/design-system-icons";
import { ActionMenu, ActionMenuItem, Button, DesignToken, Icon, Text } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { SettingsTableColumn as RawColumn, SettingsTableRow as Row } from "components/settings-table";
import { IEmailDomain } from "store/entities/email-domains";
import { withVar } from "themes/helpers";

import { DomainSetupAction } from "../DomainSetupModal";

import { DomainStatus } from "./DomainStatus";

interface IDomainListEntryProps {
  domain: IEmailDomain;
  setModalAction: (action: DomainSetupAction | null) => void;
  openDeleteModal: (domainId: string) => void;
  canManageDomains: boolean;
}

const Column: FC<{
  children: React.ReactNode;
}> = ({ children }) => <RawColumn paddingDesktop="1em 1.5em">{children}</RawColumn>;

export const DomainListEntry: FC<IDomainListEntryProps> = ({
  domain,
  setModalAction,
  openDeleteModal,
  canManageDomains,
}) => {
  return (
    <Row>
      <Column>{domain.name}</Column>
      <Column>
        <Flex justifyContent="space-between">
          <DomainStatus domain={domain} setModalAction={setModalAction} canManageDomains={canManageDomains} />
          <ActionMenu
            triggerRenderer={<Button kind="plain" icon={<Icon source={MoreHoriz} />} />}
            options={[
              {
                key: "delete",
                element: (
                  <ActionMenuItem kind="warning">
                    <Text
                      customColor={withVar(
                        !canManageDomains ? DesignToken.ActionNegativeDisabled : DesignToken.ActionNegativeDefault
                      )}
                    >
                      Delete
                    </Text>
                  </ActionMenuItem>
                ),
                onClick: () => openDeleteModal(domain.id),
                disabled: !canManageDomains,
              },
            ]}
          />
        </Flex>
      </Column>
    </Row>
  );
};
